import { useEffect } from "react";
import { useParams } from "react-router";


const useSections = () => {

  const params = useParams();

  useEffect(() => {
    null;
  }, [params]);

  const getSection = (): string | undefined => {
    const sections: { [route: string]: string } = {
      'permissions': 'permissions',
      'users': 'users',
      'nodes': 'nodes',
      'user_new': 'users',
      '': ''
    };
    return sections[getSubSection() ?? ''];
  }

  const isSection = (name: string): boolean => {
    return getSection() == name;
  }

  const getApp = (): string | undefined => {
    const parts: Array<string> = location.pathname.replace(/^[/]+/g, '').split('/');
    return parts[0];
  }

  const getSubSection = (): string | undefined => {
    const parts: Array<string> = location.hash.split('/');
    const route: string = parts[1];
    return route ?? '';
  }

  const isSubSection = (section_name: string, name: string): boolean => {
    return getSection() == section_name && getSubSection() == name;
  }

  const getPage = (): string | undefined => {
    const parts: Array<string> = location.hash.split('/');
    const route: string = parts[1];
    const page: string = parts[3];
    return ['nodes', 'users'].indexOf(route) >= 0
      ? page ?? ''
      : route == 'permissions'
        ? 'permissions'
        : '';
  }

  const getPageAndParams = (): string | undefined => {
    const parts: Array<string> = location.hash.split('/');
    const route: string = parts[1];
    const page: string = parts.slice(3).join('/');
    return ['nodes', 'users'].indexOf(route) >= 0 ? page : undefined;
  }

  return { getSection, isSection, getSubSection, isSubSection, getPage, getPageAndParams, getApp };

}

export default useSections;